// @ts-nocheck


async function fetchAllProducts() {
  try {
    const response = await fetch('/products.json');
    const data = await response.json();
    const products = data.products || [];

    const productPromises = products.map(product =>
      fetch(`/products/${product.handle}.js`)
        .then(res => res.json())
        .catch(error => {
          console.error(`Error fetching product ${product.handle}:`, error);
          return null;
        })
    );

    const allProducts = (await Promise.all(productPromises)).filter(p => p !== null);

    const script = document.querySelector('#all-products-data');
    script.textContent = JSON.stringify(allProducts);

    document.dispatchEvent(new CustomEvent('products-data-loaded', {
      detail: { dataIsReady: true, productsCount: allProducts.length }
    }));
  } catch (error) {
    console.error('Error fetching all products:', error);
  }
}


async function initializeWithRetry(maxAttempts = 4) {
  let attempt = 0;

  while (attempt < maxAttempts) {
    try {
      await fetchAllProducts();
      return;
    } catch (error) {
      attempt++;
      console.error(`Attempt ${attempt} failed:`, error);

      if (attempt >= maxAttempts) {
        console.error('Max retry attempts reached. Failed to load products data.');
        throw error;
      }

      const delay = Math.min(500 * Math.pow(2, attempt - 1), 2000);
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
}

// Initialize immediately - don't wait for Recharge
let hasInitialized = false;

function tryInitialize() {
  if (hasInitialized) return;
  hasInitialized = true;
  initializeWithRetry();
}

// Try immediately
if (window.recharge?.cdn) {
  tryInitialize();
} else {
  // Listen for Recharge loaded event
  window.addEventListener('recharge:loaded', tryInitialize);

  // Try on DOMContentLoaded regardless of Recharge status
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInitialize);
  } else {
    // Document already loaded, try now
    tryInitialize();
  }
}